import React from "react";
import { Company } from "../../Models/Company";
import {
  LoadingState,
  ApiRequest,
  ErrorDisplay,
  ResponseError,
  LoadingStateHelper,
  ResponseErrorHelper
} from "../../../Common";
import { endpoints } from "../../Constants/endpoints";
import ResponseHandler from "../../../App/ResponseHandler";
import { ResponseResult } from "../../../Common/Models/ResponseResult";
import { StatusCode } from "../../../App/Enums/StatusCode";

type Props = {
  shortname: string;
  company?: Company;
};

type State = {
  company?: Company;
  loadingState: LoadingState;
  loadingError?: ResponseError;
};

export class CompanyName extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loadingState: {
        errored: false,
        isLoaded: false,
        isLoading: false
      }
    };
  }

  componentDidMount = () => {
    if (
      !this.state.loadingState.isLoaded &&
      !this.state.loadingState.isLoading &&
      !this.props.company
    ) {
      this.loadCompany();
    }
  };

  loadCompany = () => {
    this.setState({
      loadingState: LoadingStateHelper.generate(false, true, false)
    });

    ApiRequest.fromPath(endpoints.companies.getByShortname(this.props.shortname))
      .withAuthHeader()
      .get()
      .then(response => {
        ResponseHandler.handle(
          response,
          (result: ResponseResult<Company>) => {
            this.setState(
              {
                company: result.payload
              },
              () => this.setState({ loadingState: LoadingStateHelper.generate(false, false, true) })
            );
          },
          result => {
            this.setState({
              loadingState: LoadingStateHelper.generate(true, false, false),
              loadingError: ResponseErrorHelper.generate(
                "Failed to load company",
                result.error.message,
                response.status
              )
            });
          },
          () => {
            this.setState({
              loadingState: LoadingStateHelper.generate(true, false, false),
              loadingError: ResponseErrorHelper.generate(
                "Failed to load company",
                "An unknown error has occured",
                response.status
              )
            });
          }
        ).catch(() => {
          this.setState({
            loadingState: LoadingStateHelper.generate(true, false, false),
            loadingError: ResponseErrorHelper.generate(
              "Failed to load company",
              "Unable to parse response JSON",
              response.status
            )
          });
        });
      })
      .catch(() => {
        this.setState({
          loadingState: LoadingStateHelper.generate(true, false, false),
          loadingError: ResponseErrorHelper.generate(
            "Failed to load company",
            "Failed to contact server",
            StatusCode.Status503ServiceUnavailable
          )
        });
      });
  };

  render() {
    if (this.props.company) {
      return <span>{this.props.company.name}</span>;
    }
    if (this.state.loadingState.errored && !!this.state.loadingError) {
      return <ErrorDisplay {...this.state.loadingError} />;
    }

    if (this.state.loadingState.isLoading && !this.state.loadingState.isLoaded) {
      return <span>{this.props.shortname}</span>;
    }
    if (this.state.company) {
      return <span>{this.state.company.name}</span>;
    }
    return null;
  }
}
